import Navbar from "@/components/phonetic/Navbar";
import Hero from "@/components/phonetic/Hero";
import CustomerLogos from "@/components/phonetic/CustomerLogos";
import Features from "@/components/phonetic/Features";
import Pricing from "@/components/phonetic/Pricing";
import ComparisonTable from "@/components/phonetic/ComparisonTable";
import Download from "@/components/phonetic/Download";
import DemoSection from "@/components/phonetic/DemoSection";
import Testimonials from "@/components/phonetic/Testimonials";
import FAQ from "@/components/phonetic/FAQ";
import Support from "@/components/phonetic/Support";
import Footer from "@/components/phonetic/Footer";
import StickyCTA from "@/components/phonetic/StickyCTA";

const Index = () => {
  return (
    <div className="flex flex-col min-h-screen bg-background text-foreground">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <CustomerLogos />
        <Features />
        <Pricing />
        <ComparisonTable />
        <Download />
        <DemoSection />
        <Testimonials />
        <FAQ />
        <Support />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
};

export default Index;
